import {Action, Module, Mutation, VuexModule} from 'vuex-module-decorators';

@Module({
  namespaced: true
})


export default class PaymentInterval extends VuexModule{
  paymentContributionInterval = ''

  @Mutation
  SET_PAYMENT_CONTRIBUTION_INTERVAL(interval: string){
    this.paymentContributionInterval = interval
  }

  @Action
  setPaymentContributionInterval(paymentIntervalContribution: string){
    const {commit} = this.context;
    commit('SET_PAYMENT_CONTRIBUTION_INTERVAL', paymentIntervalContribution)
  }
}
